export default function accordionOpenInit() {
	const accordionOpenBtn = document.querySelector("[data-select=accordionOpenButton]");
	const details = document.querySelectorAll("details");
	const btnText = document.querySelector("[data-open-selector]");

	const openInfo = "alle Informationen anzeigen";
	const closeInfo = "alle Informationen schließen";

	var newStatus = true;

	if (accordionOpenBtn && details && btnText) {
		accordionOpenBtn.addEventListener("click", function() {
			const status = accordionOpenBtn.getAttribute("data-status");

			if (status) {
				if (status === "closed") {
					newStatus = true;
					accordionOpenBtn.setAttribute("data-status", "open");
					btnText.textContent = closeInfo;
				} else {
					newStatus = false;
					accordionOpenBtn.setAttribute("data-status", "closed");
					btnText.textContent = openInfo;
				}
			}

			details.forEach(function(element) {
				element.open = newStatus;
			});
		});
	}
}

accordionOpenInit();
